/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import _ from 'lodash'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import MonthlyProcessEditView from '../../view/pages/monthly/EditView'
import MonthlyClosingAction from '../../action/monthly_closing'
import MonthlyClosingHeadStore from '../../store/monthly_closing/MonthlyClosingHeadStore'
import MonthlyClosingDetailsStore from '../../store/monthly_closing/MonthlyClosingDetailsStore'
import AccountTitleDetailOptionsStore from '../../store/options/AccountTitleDetailOptionsStore'
import DailyClosingSummaryStore from '../../store/monthly_closing/DailyClosingSummaryStore'
import AccountTitleDetailAction from '../../action/account_title_detail'
import EditViewStore from '../../store/monthly_closing/EditViewStore'
import LocalDate from '../../domain/type/Date'

class EditContainer extends Component {
  static getStores() {
    return [MonthlyClosingHeadStore, MonthlyClosingDetailsStore, AccountTitleDetailOptionsStore, DailyClosingSummaryStore, EditViewStore]
  }

  static calculateState(prevState, props) {
    return {
      head: MonthlyClosingHeadStore.getState(),
      details: MonthlyClosingDetailsStore.getState(),
      account_title_detail_options: AccountTitleDetailOptionsStore.getState(),
      summary: DailyClosingSummaryStore.getState(),
      view: EditViewStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    AccountTitleDetailAction.fetchAccountTitleDetails()

    if (this.state.isNew) {
      // 新規
      const hotel_id = _.get(this.state, 'match.params.hotel_id')
      const _date = _.get(this.state, 'match.params.date')
      const monthly_close_date = LocalDate.parse(_date)

      MonthlyClosingAction.fetchSummary(hotel_id, monthly_close_date)
    } else {
      // 編集
      const monthlyClosingHeadId = this.state.match.params.monthlyClosingHeadId

      if (monthlyClosingHeadId) {
        MonthlyClosingAction.fetchOne(monthlyClosingHeadId)
      }
    }
  }

  render() {
    return MonthlyProcessEditView(this.state)
  }
}

export default withRouter(Container.create(EditContainer, { withProps: true }))
